/**
 * ¿Se puede completar todavía un abono en la web? Uno fijo (`min_events` null)
 * obliga a llevar todos sus eventos y uno flexible al menos `min_events`: si ya
 * no quedan suficientes, el back rechazaría la compra y el comprador se quedaría
 * en un asistente que nunca se completa.
 */

/**
 * Los eventos de un abono ya terminados. Si el abono trae el evento entero se
 * mira su fin y si trae sesiones concretas, esas sesiones. El listado por empresa
 * no carga `session`: ahí se mira el fin del evento, y un abono con solo una
 * sesión pasada de un evento con más se detecta luego en el asistente.
 */
export function isPassEventFinished(event: any, items: any[]): boolean {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const hasNullSession = items.some((i: any) => !i.session_id);
  const sessionsLoaded = items.every((i: any) => i.session !== undefined);
  if (!hasNullSession && sessionsLoaded) {
    return items.every((i: any) => !i.session || new Date(i.session.start_date) < now);
  }
  return !!event?.end_date && new Date(event.end_date) < now;
}

export function isPassEventUnavailable(event: any, items: any[]): boolean {
  return isPassEventFinished(event, items) || !!event?.only_tpv_sales || event?.active === false;
}

/** Por qué el abono ya no se puede comprar, o null si todavía se puede. */
export function passUnavailableMessage(pass: any): string | null {
  const itemsByEvent = new Map<number, any[]>();
  for (const item of (pass?.pass_items || [])) {
    if (!item.event) continue;
    const eventId: number = item.event_id ?? item.event.id;
    itemsByEvent.set(eventId, [...(itemsByEvent.get(eventId) || []), item]);
  }
  if (itemsByEvent.size === 0) return null;

  const remaining = Array.from(itemsByEvent.values())
    .filter(items => !isPassEventUnavailable(items[0].event, items))
    .length;
  const required = pass.min_events || itemsByEvent.size;

  return remaining >= required ? null : 'Este abono ya no se puede comprar porque no quedan suficientes eventos disponibles.';
}
